import { useContext, useState, useEffect } from 'react'
import { Textfit } from "react-textfitfix"

import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined'

import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'

const StripImage = () => {

  const { template, instanceData, scannerInstanceData, model, passType, smartixPassType } = useContext(PassContext)

  const stripImage = dataSelector({ template, instanceData, scannerInstanceData, path: "meta.images.strip" })
  const primaryFields = template.primaryFields ? template.primaryFields : []

  const label = primaryFields.length ? dataSelector({ template: primaryFields[0], instanceData, scannerInstanceData, path: "label" }) : ""
  const value = primaryFields.length ? dataSelector({ template: primaryFields[0], instanceData, scannerInstanceData, path: "value" }) : ""

  const editPath = smartixPassType === "smartix_stamp" ? "stamp-images" : "meta.images.strip"
  const [imageSrc, setImageSrc] = useState(null)

  const styles = {
    stripTextColor: {
      color: stripImage ? (model.stripColor ? model.stripColor : "white") : model.foregroundColor
    }
  }

  useEffect(() => {
    if (!stripImage) return
    const img = new Image()
    img.crossOrigin = "anonymous"          // important for canvas/color picking
    img.onload = () => {
      setImageSrc(stripImage)
    }
    img.onerror = () => setImageSrc(null)
    img.src = stripImage                   // set after crossOrigin
  }, [stripImage])


  return (
    <div className="primary"> {/* Primary text overlays the strip image */}

      {stripImage &&
        <PopupEditor title="Strip Image" path={editPath}>
          <img src={imageSrc} className="strip" crossOrigin="anonymous"/>
          <div className="strip editable" />
        </PopupEditor>
      }

      {!stripImage &&
        <PopupEditor title="Strip Image" path="meta.images.strip">
          <PhotoCameraOutlinedIcon className='editIcon' style={{ fontSize: 40, position: "absolute", top: 0, right: 10, zIndex:99999 }} />
        </PopupEditor>
      }

      {smartixPassType !== "smartix_stamp" &&
        <>
          <PopupEditor title="Primary Fields" path="primaryFields" colors={{ label: model.stripColor ? "model.stripColor" : "white (fixed)", value: model.stripColor ? "model.stripColor" : "white (fixed)" }} maxFields={1}>
            <div className="item editable">
              {/* Primary text label is only shown for coupon and storeCard type */}
              {/* Where shown, the label comes AFTER the value field - hidden by CSS where not required*/}
              <Textfit mode="multi" className="value" style={styles.stripTextColor} min={12} max={60}>{value}</Textfit>
              {labelField({ styles, label, passType })}
            </div>
          </PopupEditor>
        </>}

    </div>)
}

export default StripImage

const labelField = ({ styles, label, passType }) => {
  if (["coupon", "storeCard"].includes(passType) && label.length) return <Textfit mode="single" className="label" style={styles.stripTextColor} min={10} max={20}>{label}</Textfit>
}